import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Loading, ErrorBox, Empty } from "@/components/common";
import { api, errMsg, fmtDate, downloadFile } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

const RSTATUS = { draft: ["Brouillon", "Draft"], submitted: ["Soumis pour validation", "Submitted"], final: ["Version finale", "Final"] };

export default function Reports() {
  const { tx, lbl } = useI18n();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/reports").then((r) => setRows(r.data)).catch((e) => setErr(errMsg(e))); }, []);
  if (err) return <ErrorBox error={err} />;
  return (
    <div>
      <PageHeader eyebrow={tx("Livrables", "Deliverables")} title={tx("Rapports", "Reports")} subtitle={tx("Rapports d'audit de vos missions autorisées (Word et PDF).", "Audit reports for your authorised missions (Word and PDF).")} />
      {!rows ? <Loading /> : rows.length === 0 ? <div className="card-surface"><Empty text={tx("Aucune mission", "No missions")} /></div> : (
        <div className="card-surface overflow-x-auto">
          <table className="tbl" data-testid="reports-table">
            <thead><tr><th>Client</th><th>Audit</th><th>{tx("Statut", "Status")}</th><th>{tx("Versions finales", "Final versions")}</th><th>{tx("Dernière validation", "Last approval")}</th><th>{tx("Exporter", "Export")}</th></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.audit_id} data-testid={`report-row-${r.audit_id}`}>
                <td>{r.client}</td><td><Link to={`/audits/${r.audit_id}?tab=report`} className="text-[#2176AE] hover:underline" data-testid={`report-link-${r.audit_id}`}>{r.title}</Link></td>
                <td className="text-xs">{lbl(RSTATUS, r.status)}</td><td className="font-mono">{r.final_count}</td><td className="text-xs">{r.approved_at ? fmtDate(r.approved_at) : "—"}</td>
                <td className="whitespace-nowrap">{["docx", "pdf"].map((f) => (
                  <Button key={f} size="sm" variant="outline" className="mr-1" data-testid={`reports-export-${f}-${r.audit_id}`}
                    onClick={() => downloadFile(`/audits/${r.audit_id}/report/export?format=${f}${r.final_count ? `&number=${r.final_count}` : ""}`, `rapport_${r.final_count ? `v${r.final_count}` : "brouillon"}.${f}`).catch((e) => toast.error(errMsg(e)))}>
                    {f === "docx" ? "Word" : "PDF"}</Button>))}
                  <span className="text-[10px] text-slate-400">{r.final_count ? `v${r.final_count}` : tx("brouillon", "draft")}</span></td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
